export const baseUrl = "https://api.startsole.net/sole";
